import config from 'Cloud/config';
import { getExtension, getItemNameWithoutExt } from 'reactApp/modules/file/utils';
import { renameRequest } from 'reactApp/modules/modifying/sagas/rename.saga';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

const MAX_NAME_LENGTH = config.get('ITEM_NAME_MAX_LENGTH');

export const renderRenameDialog = (item) => {
    const ext = getExtension(item.name);
    const nameWithoutExt = getItemNameWithoutExt(item.name, ext);
    const selectionRange = item.isFolder ? item.name.length : nameWithoutExt.length;

    openPopupHelper({
        popupName: popupNames.RENAME_DIALOG,
        data: {
            dataQAId: 'rename-confirmation-dialog',
            renderHeader: () => 'Переименовать',
            value: item.name,
            maxLength: MAX_NAME_LENGTH,
            waitText: 'ожидайте, идет переименование',
            successButtonText: 'Переименовать',
            onSuccess: (newName) => renameRequest(item, newName.trim().normalize()),
            selectionRange,
        },
    });
};
